import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Checkbox, useId } from "@fluentui/react-components";
import {
  ErrorMessageContainer,
  FormFieldContainer,
  StyledErrorMessage,
} from "components/styled";

type Props = {
  name: string;
  label: string;
  form: UseFormReturn<any>;
  disabled?: boolean;
};

const HookFormCheckboxField = ({
  name,
  label,
  form,
  disabled = false,
}: Props) => {
  const {
    register,
    setValue,
    formState: { errors },
    watch,
  } = form;

  const id = useId(name);
  const value = watch(name) || false;
  const error = errors[name]?.message as string;

  // Register the field
  register(name);
  const handleChange = (_event: React.FormEvent<HTMLElement>, data: any) => {
    setValue(name, data.checked, { shouldValidate: true });
  };

  return (
    <FormFieldContainer>
      <Checkbox
        id={id}
        label={label}
        checked={value}
        onChange={handleChange}
        disabled={disabled}
      />
      <ErrorMessageContainer>
        <StyledErrorMessage>{error}</StyledErrorMessage>
      </ErrorMessageContainer>
    </FormFieldContainer>
  );
};

export default HookFormCheckboxField;
